import { render, staticRenderFns } from "./AuditsHeader.vue?vue&type=template&id=2db04ba8&scoped=true"
import script from "./AuditsHeader.vue?vue&type=script&lang=js"
export * from "./AuditsHeader.vue?vue&type=script&lang=js"
import style0 from "./AuditsHeader.vue?vue&type=style&index=0&id=2db04ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db04ba8",
  null
  
)

export default component.exports